export default __webpack_public_path__ + "static/media/template-2.5596515c.jpg";